(ns common.schema.entities.workspace.kyc.questions.natural-person
  (:require
   [common.email :as common-email]
   [common.country :as country]
   [common.schema.entities.workspace.kyc.kyc-options :as kyc-options]
   [common.schema.entities.workspace.kyc.kyc-utils :as kyc-utils]))

(def all-questions
  {:kyc-person/first-name
   {:data/type    :data.type/text-simple
    :translations {:en "First name(s)"
                   :fi "Etunimet"}}
   :kyc-person/middle-names
   {:data/type    :data.type/text-simple
    :translations {:en "Middle names"
                   :fi "Toiset nimet"}}
   :kyc-person/last-name
   {:data/type    :data.type/text-simple
    :translations {:en "Last name"
                   :fi "Sukunimi"}}
   :kyc-person/nationality
   {:data/type    :data.type/keyword
    :translations {:en "Nationality"
                   :fi "Kansalaisuus"}
    :options      country/options}
   :kyc-person/nationalities
   {:data/type        :data.type/text-edn
    :edn-data/type    :edn-data.type/nationalities
    :options          country/options
    :mandatory-field? (fn [answers kyc-process]
                        (and (not= (:kyc-process/status kyc-process)
                                   :kyc-process.status/draft)
                             (kyc-utils/nationalities-unanswered?
                              answers
                              kyc-utils/person-nationality-keys)))
    :translations     {:en "Nationality"
                       :fi "Kansalaisuus"}}
   :kyc-person/dob
   {:data/type    :data.type/date
    :translations {:en "Date of birth"
                   :fi "Syntymäaika"}}
   :kyc-person/pob
   {:data/type    :data.type/text-simple
    :translations {:en "Place of birth"
                   :fi "Syntymäpaikka"}}
   :kyc-person/pin
   {:data/type    :data.type/text-simple
    :translations {:en "Personal identity number"
                   :fi "Henkilötunnus"}}
   :kyc-person/address
   {:data/type    :data.type/text-multiline
    :translations {:en "Residential address"
                   :fi "Kotiosoite"}}
   :kyc-person/zip-code
   {:data/type    :data.type/text-simple
    :translations {:en "Zip code"
                   :fi "Postinumero"}}
   :kyc-person/city
   {:data/type    :data.type/text-simple
    :translations {:en "City"
                   :fi "Kaupunki"}}
   :kyc-person/country
   {:data/type    :data.type/keyword
    :options      country/options
    :translations {:en "Country"
                   :fi "Maa"}}
   :kyc-person/tax-country
   {:data/type    :data.type/keyword
    :options      country/options
    :translations {:en "Tax country"
                   :fi "Verotuksellinen kotipaikka"}}
   :kyc-person/email
   {:data/type    :data.type/email
    :translations {:en "Email"
                   :fi "Sähköpostiosoite"}}
   :kyc-person/phone
   {:data/type    :data.type/text-simple
    :translations {:en "Phone number"
                   :fi "Puhelinnumero"}}
   :kyc-person/occupation
   {:data/type    :data.type/text-simple
    :translations {:en "Occupation or education"
                   :fi "Ammatti tai koulutustaso"}}
   :kyc-person/actual-line-of-business
   {:data/type       :data.type/text-simple
    :optional-field? true
    :translations    {:en "Actual line of business (if self-employed)"
                      :fi "Toimiala (mikäli yksityisyrittäjä)"}}
   :kyc-person/size-of-investment-portfolio
   {:data/type    :data.type/currency-value
    :translations {:en "Size of investor's investment portfolio (EUR)"
                   :fi "Sijoitusvarallisuuden arvo (EUR)"}}
   :kyc-person/source-of-funds
   {:data/type    :data.type/keyword-multi
    :options      kyc-options/source-of-funds-options-person
    :translations {:en "Source of funds"
                   :fi "Sijoitusvarojen alkuperä"}}
   :kyc-person/source-of-funds-salaries-amount
   {:data/type         :data.type/currency-value
    :conditional-field (fn [answers]
                         (some #{:source-of-funds/salaries} (:kyc-person/source-of-funds answers)))
    :translations      {:en "Annual salary circa"
                        :fi "Vuosipalkka noin"}}
   :kyc-person/source-of-funds-capital-income-amount
   {:data/type         :data.type/currency-value
    :conditional-field (fn [answers]
                         (some #{:source-of-funds/capital-income}
                               (:kyc-person/source-of-funds answers)))
    :translations      {:en "Annual capital income circa"
                        :fi "Vuosittainen pääomatulo noin"}}
   :kyc-person/source-of-funds-inheritance-amount
   {:data/type         :data.type/currency-value
    :conditional-field (fn [answers]
                         (some #{:source-of-funds/inheritance}
                               (:kyc-person/source-of-funds answers)))
    :translations      {:en "Inheritance amount circa"
                        :fi "Perinnön määrä noin"}}
   :kyc-person/source-of-funds-other-amount
   {:data/type         :data.type/currency-value
    :conditional-field (fn [answers]
                         (some #{:source-of-funds/other} (:kyc-person/source-of-funds answers)))
    :translations      {:en "Other source, amount circa"
                        :fi "Muiden varojen määrä (suuntaa-antava)"}}
   :kyc-person/source-of-funds-other-specify
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers]
                         (some #{:source-of-funds/other} (:kyc-person/source-of-funds answers)))
    :translations      {:en "Other source"
                        :fi "Muut varat, alkuperä"}}
   :kyc-person/source-of-wealth
   {:data/type :data.type/text-multiline
    :info
    {:en
     "Source of funds means the origin of the funds invested. It includes the activity and means that generated the funds used in investments. Source of wealth means the origin of total wealth."
     :fi
     "Varojen alkuperällä tarkoitetaan sijoitettavien varojen alkuperää. Määritelmään sisältyy toiminta ja keinot, jotka ovat tuottaneet sijoitettavat varat. Varallisuuden alkuperällä tarkoitetaan kokonaisvarallisuuden alkuperää."}
    :translations {:en "Source of wealth"
                   :fi "Varallisuuden alkuperä"}}
   :kyc-person/other-person-investment?
   {:data/type    :data.type/keyword
    :options      kyc-options/yes-no-options
    :translations {:en "Are you investing on someone else's behalf?"
                   :fi "Tehdäänkö sijoitus toisen henkilön puolesta?"}}
   :kyc-person/ubo-edn
   {:data/type         :data.type/text-edn
    :edn-data/type     :edn-data.type/ubo-list
    :data/template     nil ;; MUST OVERRIDE BY SCHEMA
    :conditional-field (fn [answers]
                         (= :yes (:kyc-person/other-person-investment? answers)))
    :mandatory-field? (fn [_answers kyc-process]
                        (and (not= (:kyc-process/status kyc-process)
                                   :kyc-process.status/draft)
                             (not (some #{(:kyc-process/template kyc-process)}
                                        [:kyc-template/innovestor-cofund-angel-individual]))))
    :translations      {:en "Details of the person on whose behalf the investor is investing."
                        :fi "Tiedot henkilöstä, jonka puolesta sijoitus tehdään."}}
   :kyc-person/PEP?
   {:data/type    :data.type/keyword
    :options      kyc-options/yes-no-options
    :translations {:en "Politically exposed person"
                   :fi "Poliittisesti vaikutusvaltainen henkilö"}}
   :kyc-person/pep-edn
   {:data/type         :data.type/text-edn
    :edn-data/type     :edn-data.type/pep-list
    :conditional-field (fn [answers]
                         (= :yes (:kyc-person/PEP? answers)))
    :data/template     nil ;; MUST OVERRIDE BY SCHEMA
    :translations      {:en "PEP details"
                        :fi "PEP tiedot"}}
   :kyc-person/professional-investor?
   {:data/type    :data.type/keyword
    :options      kyc-options/yes-no-options
    :translations {:en "Professional investor"
                   :fi "Ammattimainen sijoittaja"}}
   :kyc-person/professional-investor-criterias
   {:data/type         :data.type/keyword-multi
    :conditional-field (fn [answers]
                         (= :yes (:kyc-person/professional-investor? answers)))
    :translations      {:en "The investor must meet 2 of the next 3 criterias"
                        :fi "Sijoittajan täytyy täyttää 2 seuraavista 3 kriteeristä"}
    :options           kyc-options/professional-investor-options-person}
   :kyc-person/professional-investor-notes
   {:data/type         :data.type/text-multiline
    :conditional-field (fn [answers]
                         (= :yes (:kyc-person/professional-investor? answers)))
    :optional-field?   true
    :translations      {:en "Additional comments"
                        :fi "Lisätietoja"}}
   :kyc-person/non-professional-investor-notes
   {:data/type         :data.type/text-multiline
    :optional-field?   true
    :conditional-field (fn [answers]
                         (= :no (:kyc-person/professional-investor? answers)))
    :translations      {:en "Additional comments"
                        :fi "Lisätietoja"}}

   :kyc-person/tax-countries
   {:data/type     :data.type/text-edn
    :edn-data/type :edn-data.type/tax-recidencies
    :translations  {:en "Tax residencies"
                    :fi "Verotusmaat"}}
   :kyc-person/usa-tax-residency
   {:data/type    :data.type/keyword
    :options      [{:key
                    :yes

                    :translations
                    {:en
                     (str "I hereby confirm that I am a citizen of the United States of America and/or "
                          "tax resident in the USA, and that I have reported this tax residency and "
                          "my Tax Identification Number (TIN) above.")
                     :fi
                     (str
                      "Vahvistan, että sijoittaja on Yhdysvaltain kansalainen ja/tai verovelvollinen "
                      "Yhdysvalloissa, ja että hän on ilmoittanut verovelvollisuutensa sekä "
                      "veronumeronsa tällä lomakkeella.")}
                    :ord
                    1.0}
                   {:key
                    :no

                    :translations
                    {:en
                     (str "I hereby confirm that I am not a citizen of the United States of America "
                          "or tax resident in the USA.")
                     :fi
                     (str "Vahvistan, että sijoittaja ei ole Yhdysvaltain kansalainen tai "
                          "verovelvollinen Yhdysvalloissa.")}
                    :ord
                    2.0}]
    :translations {:en "Tax residency in the USA"
                   :fi "Verovelvollisuus Yhdysvalloissa"}}

   :kyc-person/capman-sanctions-confirmation
   {:data/type    :data.type/keyword
    :options      [{:ord 1.0
                    :key :yes-i-confirm
                    :translations {:en "Yes, I confirm"
                                   :fi "Kyllä, vahvistan"}}
                   {:ord 2.0
                    :key :no-i-cannot-confirm
                    :translations {:en "No, I cannot confirm"
                                   :fi "Ei, en pysty vahvistamaan"}}]

    :translations {:en "Please confirm if you comply with all applicable national and international
sanctions regulations (including sanctions imposed by Finland, the EU, UN, UK
(HMT), and the US (OFAC)) and that, to the best of your knowledge, you or any
person or entity directly or indirectly related to you (including beneficial owners,
directors, or authorised signatories) are not subject to such sanctions, asset
freezes, or trade restrictions."
                   :fi "Vahvistakaa noudatatteko kaikkia sovellettavia kansallisia ja kansainvälisiä
pakotelakeja sekä -sääntelyä (mukaan lukien Suomen, EU:n, YK:n, IsonBritannian (HMT) ja Yhdysvaltojen (OFAC) asettamat pakotteet) ja että parhaan
tietonne mukaan te tai kukaan teihin suoraan tai välillisesti liittyvä taho (mukaan
lukien tosiasialliset edunsaajat, hallituksen jäsenet tai valtuutetut
allekirjoittajat) ei ole tällaisten pakotteiden, varojen jäädyttämisen tai
kaupankäynninrajoitusten kohteena."}}

   :kyc-person/capman-sanctions-cannot-confirm-clarification
   {:data/type :data.type/text-multiline
    :translations {:en "If you cannot confirm, please provide details"
                   :fi "Jos ette pysty vahvistamaan, kertokaa tälle syy"}
    :conditional-field (fn [answers]
                         (-> answers
                             :kyc-person/capman-sanctions-confirmation
                             (= :no-i-cannot-confirm)))
    :mandatory-field?  (fn [answers]
                         (-> answers
                             :kyc-person/capman-sanctions-confirmation
                             (= :no-i-cannot-confirm)))}

   :kyc-person/number-of-documents
   {:data/type    :data.type/keyword
    :options      [{:key          :none
                    :translations {:en "None"
                                   :fi "0"}
                    :ord          0.0}
                   {:key          :one
                    :translations {:en "1"
                                   :fi "1"}
                    :ord          1.0}
                   {:key          :two
                    :translations {:en "2"
                                   :fi "2"}
                    :ord          2.0}
                   {:key          :three
                    :translations {:en "3"
                                   :fi "3"}
                    :ord          3.0}
                   {:key          :four
                    :translations {:en "4"
                                   :fi "4"}
                    :ord          4.0}
                   {:key          :five
                    :translations {:en "5"
                                   :fi "5"}
                    :ord          5.0}]
    :translations {:en "Number of additional documents"
                   :fi "Lisättävien dokumenttien lukumäärä"}}
   :kyc-person/document-1
   {:data/type         :data.type/file
    :conditional-field (fn [answers _kyc-process]
                         (some #{(:kyc-person/number-of-documents answers)}
                               [:one :two :three :four :five]))
    :translations      {:en "Document 1"
                        :fi "Dokumentti 1"}}
   :kyc-person/document-2
   {:data/type         :data.type/file
    :conditional-field (fn [answers _kyc-process]
                         (some #{(:kyc-person/number-of-documents answers)}
                               [:two :three :four :five]))
    :translations      {:en "Document 2"
                        :fi "Dokumentti 2"}}
   :kyc-person/document-3
   {:data/type         :data.type/file
    :conditional-field (fn [answers _kyc-process]
                         (some #{(:kyc-person/number-of-documents answers)} [:three :four :five]))
    :translations      {:en "Document 3"
                        :fi "Dokumentti 3"}}
   :kyc-person/document-4
   {:data/type         :data.type/file
    :conditional-field (fn [answers _kyc-process]
                         (some #{(:kyc-person/number-of-documents answers)} [:four :five]))
    :translations      {:en "Document 4"
                        :fi "Dokumentti 4"}}
   :kyc-person/document-5
   {:data/type         :data.type/file
    :conditional-field (fn [answers _kyc-process]
                         (some #{(:kyc-person/number-of-documents answers)} [:five]))
    :translations      {:en "Document 5"
                        :fi "Dokumentti 5"}}

   :kyc-person/signer-email
   {:data/type      :data.type/email
    :mandatory-field?  (fn [_answers kyc-process]
                         (= :kyc-process.status/wip (:kyc-process/status kyc-process)))
    :validation-fn  (fn [{:keys [answers]}]
                      (when-not (common-email/optional-valid-email? (:kyc-person/signer-email answers))
                        :invalid-email))
    :translations {:en "Signer's email"
                   :fi "Allekirjoittajan sähköpostiosoite"}}

   :kyc-person/type-of-identification-attachment
   {:data/type    :data.type/keyword
    :options      kyc-options/signer-identification-options
    :translations {:en "Identification type"
                   :fi "Tunnistamisasiakirjan tyyppi"}}
   :kyc-person/identification-expires
   {:data/type    :data.type/date
    :translations {:en "Identification document expiration date"
                   :fi "Tunnistamisasiakirjan viimeinen voimassaolopäivä"}}
   :kyc-person/identification-attachment
   {:data/type         :data.type/file
    :conditional-field (fn [answers _kyc-process]
                         (not= :identification.type/provided-in-previous-questions
                               (:kyc-person/type-of-identification-attachment answers)))
    :mandatory-field?  (fn [answers _kyc-process]
                         (not= :identification.type/provided-in-previous-questions
                               (:kyc-person/type-of-identification-attachment answers)))
    :translations      {:en "Upload certified copy of a valid identification"
                        :fi "Liitä oikeaksi todistettu kopio voimassaolevasta asiakirjasta"}}
   :kyc-person/identification-attachment-not-certified
   {:data/type         :data.type/file
    :conditional-field (fn [answers _kyc-process]
                         (not= :identification.type/provided-in-previous-questions
                               (:kyc-person/type-of-identification-attachment answers)))
    :mandatory-field?  (fn [answers _kyc-process]
                         (not= :identification.type/provided-in-previous-questions
                               (:kyc-person/type-of-identification-attachment answers)))
    :translations      {:en "Upload copy of a valid identification"
                        :fi "Liitä kopio voimassaolevasta asiakirjasta"}}

   :kyc-person/national-id-card-front-side-file
   {:data/type :data.type/file
    :translations {:en "Copy of national ID card (front side)"
                   :fi "Henkilökortin kopio (etuosa)"}}

   :kyc-person/national-id-card-back-side-file
   {:data/type :data.type/file
    :translations {:en "Copy of national ID card (back side)"
                   :fi "Henkilökortin kopio (takaosa)"}}

   :kyc-person/passport-photo-page-file
   {:data/type :data.type/file
    :translations {:en "Copy of passport (photo page)"
                   :fi "Passikopio (kuvasivu)"}}

   :kyc-person/confirmation-place
   {:data/type    :data.type/text-simple
    :translations {:en "Place"
                   :fi "Paikka"}}
   :kyc-person/confirmation-date
   {:data/type         :data.type/datetime
    :translations      {:en "Date"
                        :fi "Aika"}
    :conditional-field (fn [_answers _kyc-process]
                         false)
    :field/default-authorization {:access/write :role/system}}
   :kyc-person/confirmation-name
   {:data/type    :data.type/text-simple
    :translations {:en "Name"
                   :fi "Nimi"}}

   :kyc-person/signature-confirmation
   {:data/type :data.type/info
    :optional-field? true
    :translations
    {:en
     (str "On behalf of the investor, I hereby confirm that the information I have "
          "declared in this form and in its appendices are true and correct. "
          "I undertake to inform any changes to the declared information within 30 days.")
     :fi
     (str "Vakuutan, että tässä lomakkeessa ja sen liitteissä olevat tiedot ovat oikeita, "
          "ja että sijoittaja sitoutuu ilmoittamaan näiden tietojen muutoksist 30 "
          "päivän kuluessa muutoksesta.")}}
   :kyc-person/confirm-marketing-consent
   {:data/type    :data.type/confirm
    :translations {:en "I give my consent for the provided contact information to be used for direct marketing by electronic means."
                   :fi "Annan suostumukseni ilmoittamieni yhteystietojen käyttämiseen sähköisessä suoramarkkinoinnissa."}}})
